import { CButton, CCardBody, CCardHeader, CCol, CRow } from "@coreui/react";
import React from "react";
// import usersData from "../users/UsersData";

const Agreementform = () => {
  return (
    <>
      <CCardHeader className="mb-3 shadow-sm">
        <CRow className="pt-3" xl={12}>
          <CCol xl={10}>
            <h3>Agreement Form</h3>
          </CCol>
        </CRow>
        <hr />
        <CCardBody>
          {/* <CCardBody className="shadow-lg p-3 mb-5 bg-body rounded"> */}
          <CRow className="mb-2">
            <CCol xl={3}>
              <label for="loginid">Login Id : </label>
              <input type="text" class="form-control" id="loginid" />
            </CCol>
            <CCol xl={3}>
              <label for="companyname">Company Name : </label>
              <input type="text" class="form-control" id="companyname" />
            </CCol>
          </CRow>
          <CRow className="mb-2">
            <CCol xl={3}>
              <label for="lotno">Lot number : </label>
              <input type="text" class="form-control" id="lotno" />
            </CCol>
            <CCol xl={3}>
              <label for="purchaseratepersb">Purchase Rate per S.B : </label>
              <input type="text" class="form-control" id="purchaseratepersb" />
            </CCol>
          </CRow>
          <CRow className="mb-2">
            <CCol xl={3}>
              <label for="purchaseprice">Purchase Price : </label>
              <input type="text" class="form-control" id="purchaseprice" />
            </CCol>
          </CRow>
          <CButton type="submit" class="btn btn-success mt-5">
            Approve Agreeme
          </CButton>
        </CCardBody>
      </CCardHeader>
    </>
  );
};
export default Agreementform;
